import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="certificacoes"]');

class Certificacoes {
    constructor() {
        this.components = MODULE;
        this.breakpoint = window.matchMedia('(min-width: 768px)');
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('.swiper');
            if (!swiperEl) return;

            const state = { swiper: null };
            const handle = () => this.handle(component, swiperEl, state);

            this.breakpoint.addEventListener('change', handle);
            handle();
        });
    }

    handle(component, swiperEl, state) {
        if (state.swiper) {
            state.swiper.destroy(true, true);
            state.swiper = null;
        }

        const slides = swiperEl.querySelectorAll('.swiper-slide');
        const isDesktop = this.breakpoint.matches;

        const minSlides = isDesktop ? 6 : 2;
        const shouldInitSwiper = slides.length >= minSlides;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        const staticClasses = [
            'is-static',
            'justify-center',
            'space-x-5',
        ];

        staticClasses.forEach((className) => {
            wrapper?.classList.toggle(
                className,
                !shouldInitSwiper
            );
        });

        if (!shouldInitSwiper) {
            return;
        }

        state.swiper = new Swiper(swiperEl, {
            modules: [FreeMode],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: false,
            grabCursor: true,
            watchOverflow: true,

            freeMode: {
                enabled: true,
                sticky: false,
            },
        });
    }
}

(() => {
    if (MODULE.length) {
        new Certificacoes();
    }
})();

export default Certificacoes;
